import i18n from '@/lib/i18n';
import { zeroPad } from 'react-countdown';

import Lesson from '@/models/Lesson';
import ScheduledLesson, {
  ScheduledLessonTypeEnum,
} from '@/models/ScheduledLesson';

export const formatLessonName = (
  lesson: Lesson,
  scheduledLesson?: ScheduledLesson,
): string => {
  const { name } = lesson;
  if (scheduledLesson && !scheduledLesson.isActive) {
    return formatOldNames(name);
  }

  const lessonOrder = lesson.order ?? scheduledLesson?.order;

  const scheduledLessonType =
    scheduledLesson?.type ??
    (lessonOrder
      ? ScheduledLessonTypeEnum.NORMAL
      : ScheduledLessonTypeEnum.EXTRA);

  const prefix = formatLessonNamePrefix({
    lessonOrder,
    scheduledLessonType,
  });

  return `${prefix} - ${formatOldNames(name)}`;
};

const extraLessonPrefix = 'Aula Extra';

export const formatOldNames = (name: string) =>
  name ? name.replace(/Aula [0-9]+ - /, '') : '';

interface FormatLessonNamePrefixParam {
  lessonOrder: number;
  scheduledLessonType?: ScheduledLessonTypeEnum;
}

export const formatLessonNamePrefix = ({
  lessonOrder,
  scheduledLessonType,
}: FormatLessonNamePrefixParam) => {
  if (lessonOrder === undefined && !scheduledLessonType) return '';

  if (
    scheduledLessonType !== ScheduledLessonTypeEnum.NORMAL &&
    scheduledLessonType
  )
    return extraLessonPrefix;

  return i18n.t('common.lesson', {
    order: zeroPad(lessonOrder, 2),
  });
};
